import "./App.css";
import { Routes, Route, useSearchParams, useLocation } from "react-router-dom";
import Navbar from "./components/Navbar/Navbar";
import Banner from "./components/Banner/Banner";
import { MDBContainer } from "mdb-react-ui-kit";
import Footer from "./components/Footer/Footer";
import Riwayat from "./pages/Riwayat/Riwayat";
import Home from "./pages/Home/Home";
import NotFound from "./pages/404/404";
import { useEffect, useState } from "react";
import Klaim from "./pages/Klaim/Klaim";
import KlaimKalog from "./pages/KlaimKalog/Klaim";
import RiwayatDetail from "./pages/Riwayat/RiwayatDetail";
import ScrollToTop from "./components/ScrollToTop";
import History from "./pages/KlaimRecon/History";
import HistoryDetail from "./pages/KlaimRecon/HistoryDetail";
import BundleCargoList from "./pages/Klaim/BundleCargoList";

function App() {
  const [searchParams] = useSearchParams();
  const signatureParams = searchParams.get("signature");
  const location = useLocation();
  const isClaimRecon = location.pathname.includes("/claim-recon");
  
  useEffect(() => {
    if (isClaimRecon && signatureParams) {
      sessionStorage.setItem("signature", signatureParams)
      sessionStorage.setItem("activePage", "history-claim-recon");
      setSignature(signatureParams);
    }
    const token = sessionStorage.getItem("token");
    const userCode = sessionStorage.getItem("userCode");
    const signature = sessionStorage.getItem("signature");
    const isKalog = sessionStorage.getItem("isKalog") && sessionStorage.getItem("isKalog").toUpperCase() === 'TRUE' ? true : false;

    setToken(token);
    setUserCode(userCode);
    setSignature(signature);
    setIsKalog(isKalog);
  }, [signatureParams, isClaimRecon]);

  const [token, setToken] = useState(null);
  const [userCode, setUserCode] = useState(null);
  const [signature, setSignature] = useState(null);
  const [isKalog, setIsKalog] = useState(null);

  return (
    <div className="App">
      <Navbar />

      <main>
        <ScrollToTop />

        <Routes>
          <Route
            path="/"
            element={
              <MDBContainer>
                <Home />
              </MDBContainer>
            }
          />

          <Route
            path="/riwayat"
            element={
              <MDBContainer>
                {(token && userCode) || (userCode && signature) ? (
                  <>
                    <Banner />
                    <Riwayat />
                  </>
                ) : (
                  <NotFound />
                )}
              </MDBContainer>
            }
          />

          <Route
            path="/riwayat/:id"
            element={
              (token && userCode) || (userCode && signature) ? (
                <RiwayatDetail />
              ) : (
                <NotFound />
              )
            }
          />

          <Route
            path="/klaim/*"
            element={
              <MDBContainer>
                {(token && userCode) || (userCode && signature) ? (
                  <>
                    <Banner />
                    <Klaim />
                  </>
                ) : (
                  <NotFound />
                )}
              </MDBContainer>
            }
          />

          <Route
            path="/bundle-klaim/:uniqId"
            element={
              <MDBContainer>
                {(token && userCode) || (userCode && signature) ? (
                  <>
                    <Banner />
                    <BundleCargoList />
                  </>
                ) : (
                  <NotFound />
                )}
              </MDBContainer>
            }
          />

          <Route
            path="/klaim-kalog/*"
            element={
              <MDBContainer>
                {userCode && isKalog ? (
                  <>
                    <Banner />
                    <KlaimKalog />
                  </>
                ) : (
                  <NotFound />
                )}
              </MDBContainer>
            }
          />

          <Route
            path="/claim-recon/:uniqId"
            element={
              <MDBContainer>
                {signature ? (
                  <>
                    <Banner />
                    <History />
                  </>
                ) : (
                  <NotFound />
                )}
              </MDBContainer>
            }
          />
          <Route
            path="/claim-recon/detail/:id"
            element={
              (signature) ? (
                <HistoryDetail />
              ) : (
                <NotFound />
              )
            }
          />

          <Route
            path="*"
            element={
              <MDBContainer>
                <NotFound />
              </MDBContainer>
            }
          />
        </Routes>
      </main>

      <Footer />
    </div>
  );
}

export default App;
